import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import axios from 'axios';
import { TCloudinaryUploadResponse } from '~/types/server.types';
import { TUploadedFile } from '~/common/useAssetLibrary';

const CLOUDINARY_UPLOAD_PRESET = 'fxuwjbjr';

export class ImageAdapter extends BaseHttpAdapter {
    async uploadToCloudinary(
        file: TUploadedFile | string,
        folder: string,
        onUploadProgress: ({
            loaded,
            total
        }: {
            loaded: number;
            total: number;
        }) => void,
        cloudinary_public_id?: string
    ) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
        if (folder) {
            formData.append('folder', folder);
        }
        if (cloudinary_public_id) {
            formData.append('public_id', cloudinary_public_id.trim());
        }
        const { data } = await axios.request<TCloudinaryUploadResponse>({
            url: 'https://api.cloudinary.com/v1_1/honeybook/upload',
            method: 'POST',
            data: formData,
            onUploadProgress
        });
        return data;
    }
}
